import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderOffer extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/offer`)
  }

  // create offer
  createFurnitureOffer(model, showProgress) {
    return this._request({
      action: 'create/furniture',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  createCargoOffer(model, showProgress) {
    return this._request({
      action: 'create/cargo',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  createTrashOffer(model, showProgress) {
    return this._request({
      action: 'create/trash',
      method: 'POST',
      body: model,
      showProgress
    })
  }
  // ----------

  auctionPricing(offerId, model, showProgress) {
    return this._request({
      action: `${offerId}/pricing/auction`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  updateExcess(offerId, model, showProgress) {
    return this._request({
      action: `${offerId}/excess`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  // accept offer
  acceptTariffBased(offerId, showProgress) {
    return this._request({
      action: `${offerId}/accept/tariff`,
      method: 'PATCH',
      showProgress
    })
  }

  acceptAuction(offerId, showProgress) {
    return this._request({
      action: `${offerId}/accept/auction`,
      method: 'PATCH',
      showProgress
    })
  }

  cancelOffer(offerId, showProgress) {
    return this._request({
      action: `${offerId}`,
      method: 'DELETE',
      showProgress
    })
  }

  acceptableOffer(offerId, showProgress) {
    return this._request({
      action: `${offerId}/acceptable`,
      method: 'PATCH',
      showProgress
    })
  }
}
